import { lowerCase } from "lodash";
import { Link, animateScroll as scroll } from "react-scroll";

export default ({ location }) => {
    return (
        <div className="bg-black overflow-hidden">
            <div className="relative max-w-7xl mx-auto xs:py-4 sm:py-4 md:py-8 lg:py-16 px-4 sm:px-6 lg:px-8">
                <div className="mx-auto lg:grid lg:grid-cols-2 lg:gap-8 lg:max-w-none">
                    <h2 className="xs:text-center sm:text-center mt-2 col-start-2 col-end-2 text-5xl text-white font-custom italic font-bold uppercase">
                        Afvallen zonder een jojo-effect!
                    </h2>
                </div>
                <div className="mt-8 lg:grid lg:grid-cols-2 lg:gap-8">
                    <div className="mt-8 lg:mt-0 xs:mb-16 sm:mb-16">
                        <div className="relative text-base mx-auto max-w-prose lg:max-w-none">
                            <div className="aspect-w-12 aspect-h-7 lg:aspect-none">
                                <picture>
                                    <source
                                        srcSet={`/assets/webp/personal-training-${lowerCase(
                                            location
                                        )}.webp`}
                                        width={1440}
                                        height={960}
                                        type="image/webp"
                                        alt="Boek succesvol afvallen zonder voedingsschema"
                                        className="rounded-lg shadow-lg object-cover object-center"
                                    />
                                    <source
                                        srcSet={`/assets/personal-training-${lowerCase(
                                            location
                                        )}.jpg`}
                                        width={1440}
                                        height={960}
                                        type="image/jpeg"
                                        alt="Boek succesvol afvallen zonder voedingsschema"
                                        className="rounded-lg shadow-lg object-cover object-center"
                                    />
                                    <img
                                        src={`/assets/personal-training-${lowerCase(
                                            location
                                        )}.jpg`}
                                        width={1440}
                                        height={960}
                                        alt="Boek succesvol afvallen zonder voedingsschema"
                                        className="rounded-lg shadow-lg object-cover object-center"
                                    />
                                </picture>
                            </div>
                        </div>
                    </div>
                    <div className="relative lg:row-start-1 lg:col-start-2 mt-8 lg:mt-0">
                        <div className="text-base max-w-prose mx-auto lg:max-w-none">
                            <p className="text-lg text-gray-100">
                                Waarschijnlijk heb je al meerdere pogingen
                                gedaan die telkens niet slaagde omdat je aan het
                                jojoën ging. Dit is een veelvoorkomende probleem
                                van onze potentiële leden in {location}. Met ons
                                uniek twaalf weken programma leren we onze leden
                                hoe ze dit kunnen voorkomen en bieden we de
                                onbeperkt nazorg om een terugval uit te sluiten.
                            </p>
                            <p className="text-lg mt-4 text-gray-100">
                                Eerst gaan we twaalf weken aan de slag met
                                Personal Training of Small Group training. Deze
                                twaalf weken zijn onderverdeeld in drie fases
                                waarin we je steeds meer vrijheid bieden.
                                Hierdoor realiseren we stapsgewijs een leefstijl
                                die passend is bij jouw leven. Na deze drie
                                fases staan onze Personal Trainers voor je klaar
                                om je een warm welkom te heten in onze private
                                gym in {location}. Samen ga je de behaalde
                                resultaten onderhouden om ervoor te zorgen dat
                                je nooit meer terugvalt!
                            </p>
                            <div className="xs:text-center sm:text-center">
                                <Link
                                    to="contact"
                                    smooth={true}
                                    offset={0}
                                    duration={500}
                                    className="mt-12 uppercase inline-flex items-center justify-center cursor-pointer px-6 py-3 border border-transparent text-base font-semibold rounded-md shadow-sm text-black bg-we-are-yellow focus:outline-none focus:ring-2 focus:ring-offset-2"
                                >
                                    Ik wil dit ook!
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
